import React from "react";
import { useLocation } from "@reach/router";

import {
    container,
    header,
    content,
    savedStylizationContainer,
    savedStylizationHeader,
    savedStylizationContent,
} from "./generator-layout.module.scss";

import MainLayout from "./main-layout";
import HeaderSurvey from "../components/organisms/headers/headerSurvey";
import { GeneratorHeaderSaveProvider } from "../contexts/generator-header-save.context";

interface IGeneratorLayoutProps {
    className?: string;
    children?: React.ReactNode;
}

const GeneratorLayout: React.FC<IGeneratorLayoutProps> = ({ children }) => {
    const { pathname } = useLocation();
    const isSavedStylizationView = /\/generator\/stylizacja\//.test(pathname || "");

    return (
        <GeneratorHeaderSaveProvider>
            <MainLayout
                containerClassName={`${container} ${isSavedStylizationView ? savedStylizationContainer : ""}`}
                HeaderComponent={<HeaderSurvey />}
                headerClassName={`${header} ${isSavedStylizationView ? savedStylizationHeader : ""}`}
                hasPaddingTop={true}
                footerVisible={false}
            >
                <div className={`${content} ${isSavedStylizationView ? savedStylizationContent : ""}`}>
                    {children}
                </div>
            </MainLayout>
        </GeneratorHeaderSaveProvider>
    );
};

export default GeneratorLayout;
